import ClientIngestion from "../../../components/client-ingestion/client-ingestion";
import Page from "../../page";

const ClientIngestionPage = () => {
  return (
    <Page>
      <ClientIngestion />
    </Page>
  );
};

export default ClientIngestionPage;
